export const ANALYTICS_HEADER_TAB_OPTIONS = [
  { label: "Reports", value: "reports" },
  { label: "Process", value: "process" },
  { label: "Limit", value: "limit" },
  { label: "Batches", value: "batches" },
  { label: "Visualization", value: "visualization" },
];

export const BREADCRUMB_NAV_TAB_MAP = {
  reports: "Reports",
  "create-report": "Create New Report",
  process: "Process",
  limits: "Limits",
  batches: "Batches",
  visualization: "Visualization",
  charts: "Charts",
  "audit-trail": "Audit Trail",
  genealogy: "Genealogy",
  create: "New Report",
  edit: "Edit Report",
  view: "View Report",
  dashboard: "Dashboard",
};
